import React, { useEffect, useState } from 'react';
import Tippy from '@tippyjs/react';
import { toastError } from "../../../shared/toastHelper";

const axios = require('axios').default;

const commonTagClasses = "small rounded-pill btn cal-tag-pill";

const TagFilter = ({
  team,
  csrfToken,
  scope,
  currentTags,
  onChange,
}) => {
  const [tags, setTags] = useState([]);
  const [activeTags, setActiveTags] = useState(currentTags);
  const [tagFilter, setTagFilter] = useState("");

  const fetchTags = () => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.get(`/teams/${team.id}/tags`, {
      params: { scope: scope }
    })
      .then(({ data }) => setTags(data))
      .catch(error => toastError("Something went wrong. Try again."));
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return(
    <div className="text-left">
      <div className="input-group" style={{"marginTop": "4px"}}>
        <input
          type="text"
          id="tag-filter"
          className="form-control pl-2 py-1 small border-right-0 shadow-none"
          style={{borderColor: "var(--od-c-eeeeee, #EEEEEE)", borderWidth: "1px"}}
          placeholder="Search tags..."
          value={tagFilter}
          onChange={e => setTagFilter(e.target.value)}
        />
        <div className="input-group-append">
          <span
            className="input-group-text bg-white border-left-0"
            style={{borderColor: "var(--od-c-eeeeee, #EEEEEE)", borderWidth: "1px"}}
          >
            <i className="fa fa-search"></i>
          </span>
        </div>
      </div>
      <div style={{"marginTop": "5px"}}>
        {tags
          .filter(tag => tag.name.toLowerCase().includes(tagFilter.toLowerCase()))
          .map(tag => {
            const style = activeTags.includes(tag.name) ? {
              color: "var(--od-c-ffffff, #FFF)",
              backgroundColor: "var(--od-c-1982c4, #1982C4)",
            } : {
              color: "var(--od-c-1982c4, #1982C4)",
              backgroundColor: "#e8f3f9",
            };

            return(
              <div
                key={tag.name}
                className={`${commonTagClasses}${activeTags.includes(tag.name) ? ' cal-tag-pill--active' : ''}`}
                style={{
                  ...style,
                  fontSize: "10px",
                  padding: "3px 7px",
                  fontWeight: 600,
                  margin: "0px 3px 3px 0px"
                }}
                onClick={() => {
                  if(activeTags.includes(tag.name)){
                    const newActiveTags = activeTags.filter(activeTag => activeTag !== tag.name);

                    setActiveTags(newActiveTags);
                    onChange(newActiveTags);
                  } else {
                    const newActiveTags = [...activeTags, tag.name];

                    setActiveTags(newActiveTags);
                    onChange(newActiveTags);
                  }
                }}
              >
                {tag.name}
              </div>
            );
          })
        }
      </div>
    </div>
  )
}

TagFilter.propTypes = {
};

export default TagFilter;
